module.exports = __webpack_public_path__ + "img/buy_normal_ph.509d4fc2.png";